<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Wizard Desc.">
      <b-form-input
        @change="changeProp"
        v-model="field.params.wizard_description"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Start button">
      <b-form-input @change="changeProp" v-model="field.params.start_button" />
    </b-form-group>

    <b-form-group label-cols="3" label="Back button">
      <b-form-input @change="changeProp" v-model="field.params.back_button" />
    </b-form-group>

    <b-form-group label-cols="3" label="Next button">
      <b-form-input @change="changeProp" v-model="field.params.next_button" />
    </b-form-group>

    <b-form-group label-cols="3" label="Buttons alignment">
      <b-form-select
        @change="changeProp"
        v-model="field.params.buttons_alignment"
      >
        <option value="">Left</option>
        <option value="text-center">Center</option>
        <option value="text-right">Right</option>
      </b-form-select>
    </b-form-group>

    <b-form-group label-cols="3" label="Steps color">
      <b-form-select @change="changeProp" v-model="field.params.steps_color">
        <option value="red">Red</option>
        <option value="green">Green</option>
        <option value="blue">Blue</option>
        <option value="black">Black</option>
      </b-form-select>
    </b-form-group>

    <b-form-group label-cols="3" label="Widgets">
      <f-child-fields
        :fields="field.fields"
        @change="on_changed_fields"
        @select="on_select"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Insert wizard steps">
      <b-button @click="addStep">Add Step</b-button>
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import FSelectField from "../../FSelectField.vue";
import { FIELD_TYPES_BY_CODE } from "../../field_types.js";
import WidgetPropMixin from "../WidgetPropMixin.js";
import FChildFields from "../FChildFields.vue";

export default {
  name: "WizardProps",
  components: { FChildFields, FSelectField, WidgetCommonProps },
  mixins: [WidgetPropMixin],

  computed: {},

  methods: {
    addStep() {
      this.addFieldByType("wizardstep");
    },

    addFieldByType(type_name) {
      this.addField(FIELD_TYPES_BY_CODE[type_name]);
    },

    addField(typeDef) {
      var newItemNo = this.field.fields.length + 1;

      var newField = {
        display_order: newItemNo,
        field_type: typeDef.code,
        code: "step" + "_" + newItemNo,
        name: "Step" + " " + newItemNo,
        params: _.cloneDeep(typeDef.params),
        value: _.cloneDeep(typeDef.value),
        has_score: false,
        max_score: 100,
        min_score: 0,
        visible: false,

        _locked: false,
        _newfield: true,
      };

      if (typeDef.container == true) {
        newField.fields = []; // init blank array
      }

      var fields = this.field.fields || [];

      fields.push(newField);

      if (this.formState) this.formState.dirty = true;

      console.log(`[${new Date().toISOString()}] WizardProps @change event:`, {
        component: "WizardProps",
        method: "addField",
        fieldCode: this.field.code,
        fieldsCount: fields.length,
        newFieldType: typeDef.code,
        fields: fields,
      });
      this.$emit("change", fields);
      if (this.selector) {
        this.selector.selectThis(newField, this.field.fields);
        this.selector.editThis(newField, this.field.fields);
      }
    },
  },
};
</script>
